import { flatMap, groupBy, keyBy, mapValues } from 'lodash';
import { useSelector } from 'react-redux';
import { VERTICALS_MAP } from '../shared/Constants/Constants';
import { useAccount } from './useAccount';

export const useMaterialCategory = () => {
  const browseNodes = useSelector(({ browseNodes }) => browseNodes.data);
  return browseNodes;
};

export const useItemCategory = () => {
  const browseNodeItemsData = [];
  const browseNodes = useSelector(({ browseNodes }) => browseNodes.data);
  for (let item of browseNodes) {
    const itemData = item?.items?.map((data) => data);
    browseNodeItemsData.push(...itemData);
  }
  return browseNodeItemsData;
};

export const useCombinedMaterialCategory = () => {
  const browseNodes = useSelector(({ browseNodes }) => browseNodes.data);
  const newBrowseNodes = [];
  const plasticObj = { id: '4', title: 'Plastic', items: [] };
  browseNodes.forEach((element) => {
    if (['1', '2', '4', '6']?.includes(element?.id)) {
      plasticObj.items = [...element.items, ...plasticObj.items];
    } else {
      newBrowseNodes.push(element);
    }
  });
  newBrowseNodes.unshift(plasticObj);

  return newBrowseNodes;
};

export const useBrowseNodeMap = () => {
  const browseNodes = useSelector(({ browseNodes }) => browseNodes.data);
  let categoriesById = keyBy(browseNodes, 'id');
  let itemsById = keyBy(flatMap(browseNodes, 'items'), 'id');
  return { categoriesById, itemsById };
};

export const useCategoryByItemId = () => {
  const browseNodes = useSelector(({ browseNodes }) => browseNodes.data);
  const items = keyBy(
    flatMap(
      browseNodes?.map((browseNode) => {
        return browseNode?.items?.map((item) => {
          return { browseNodeId: browseNode?.id, vertical: browseNode?.vertical, ...item };
        });
      })
    ),
    'id'
  );
  return items;
};

export const useBrowseNodesByVertical = () => {
  const browseNodes = useSelector(({ browseNodes }) => browseNodes.data);
  const account = useAccount();
  return browseNodes?.filter((node) => account?.user?.businessVerticals.includes(node?.vertical));
};

export const useBrowseNodeMaterials = (flat = true, groupBy = 'id') => {
  const browseNodesMaterialsList = useSelector(({ browseNodes }) => browseNodes?.materialsData);
  return flat ? browseNodesMaterialsList : keyBy(browseNodesMaterialsList, groupBy);
};

export const useEwasteMaterialsByItemId = () => {
  const items = useCategoryByItemId();
  const materialsList = useBrowseNodeMaterials();

  const filteredMaterialsList = materialsList?.filter(
    (material) => items?.[material.browseNodeItemId]?.vertical === VERTICALS_MAP.E_WASTE.label
  );

  return mapValues(groupBy(filteredMaterialsList, 'name'), (groupedByName) =>
    keyBy(groupedByName, 'browseNodeItemId')
  );
};

export const useEwasteMaterialsByMaterialId = () => {
  const items = useCategoryByItemId();
  const materialsList = useBrowseNodeMaterials();

  const filteredMaterialsList = materialsList?.filter(
    (material) => items?.[material.browseNodeItemId]?.vertical === VERTICALS_MAP.E_WASTE.label
  );

  return keyBy(filteredMaterialsList, 'id');
};

export const useBrowseNodeMaterialRules = (vertical = 'E_WASTE', category = 'E-Waste') => {
  const rules = useSelector(({ rules }) => rules?.data);

  if (!rules) return {};
  const creditRules = rules?.filter(
    (rule) =>
      rule?.keyValue1 === 'CREDITS' && rule?.keyValue2 === vertical && rule?.keyValue3 === category
  );

  return mapValues(groupBy(creditRules, 'keyValue5'), (groupedByMaterial) =>
    mapValues(groupBy(groupedByMaterial, 'keyValue4'), (groupedByItem) =>
      mapValues(
        keyBy(
          flatMap(
            groupedByItem
              ?.filter((item) => item.isActive)
              ?.map((item) => item.formulas?.filter((item) => item.targetUnitName === 'CREDITS'))
          ),
          'yearRange'
        )
      )
    )
  );
};
